<dv-grid>
  <dv-panel
    class="trip-import-filter-panel"
    [showExpandButton]="false"
    [showPinButton]="false"
    [isPinned]="true"
    [isClosedPanelVisible]="false"
    [closedPanelTitle]="' '">
    <dv-dynamic-form
      [elements]="panelFormElements"
      [formGroup]="panelFormGroup">
    </dv-dynamic-form>
  </dv-panel>
  <ag-grid-angular
    class="ag-theme-devinco"
    [gridOptions]="gridOptions"
    [customGridId]="'TripImportGrid'"
    (filterChanged)="onFilterChanged()"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="onSelectionChanged($event)">
  </ag-grid-angular>
</dv-grid>
